import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { ICaixaDescricaoFilter } from '@services/CaixaService';
import React from 'react';

export type CaixaDescricaoFilterProps = {
    filter: IFilter<ICaixaDescricaoFilter>
    isLoading: boolean
}

export function CaixaDescricaoFilter ({ filter, isLoading }: CaixaDescricaoFilterProps) {
    const clienteNomeInputRef = React.createRef<HTMLInputElement>();
    
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
        clienteNomeInputRef.current?.focus();
    }, [filter, clienteNomeInputRef]);

    React.useEffect(() => {
        clienteNomeInputRef.current?.focus();
    }, [clienteNomeInputRef])

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={6}>
                    <StringField
                        field={filter.fields.descricao}
                        label="Descrição"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
           </HorizontalGrid>
        </FixedFilterPanel>
    )
}